import NumberInput from "components/Common/NumberInput"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Collapse, Row } from "reactstrap"
import { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import Select from "react-select"
import { GetPartnerCockpits } from "helpers/backend_helper"
const { SearchBar } = Search

const PartFilter = ({
  isOpen,
  parts,
  setParts,
  isWatchlist = false,
  searchProps,
  showPartnerCockpitFilter = false,
  showCPNFilter = false,
  showCompanyCategoryFilter = false,
  includeTraderArticles = true,
  showStockType = false,
}) => {
  const [manufacturer, setManufacturer] = useState("")
  const [mpn, setMPN] = useState("")
  const [cpn, setCPN] = useState("")
  const [priceFrom, setPriceFrom] = useState(0)
  const [priceTo, setPriceTo] = useState(0)
  const [quantityFrom, setQuantityFrom] = useState(0)
  const [quantityTo, setQuantityTo] = useState(0)
  const [isHighrunner, setIsHighrunner] = useState("")
  const [currency, setCurrency] = useState("")
  const [type, setType] = useState("")
  const [partnerCockpit, setPartnerCockpit] = useState({
    value: null,
    label: "",
  })
  const [partnerCockpits, setPartnerCockpits] = useState([])
  const [companyCategoryOemEms, setCompanyCategoryOemEms] = useState(true)
  const [companyCategoryTrader, setCompanyCategoryTrader] = useState(includeTraderArticles)

  useEffect(() => {
    const loadPartnerCockpits = async () => {
      try {
        const cockpits = await GetPartnerCockpits()
        setPartnerCockpits(cockpits)
      } catch (error) {
        console.error("Error loading partner cockpits:", error)
      }
    }

    if (showPartnerCockpitFilter) {
      loadPartnerCockpits()
    }
  }, [showPartnerCockpitFilter])

  useEffect(() => {
    filterParts()
  }, [
    manufacturer,
    priceFrom,
    priceTo,
    quantityFrom,
    quantityTo,
    isHighrunner,
    type,
    currency,
    mpn,
    cpn,
    partnerCockpit,
    companyCategoryOemEms,
    companyCategoryTrader,
  ])

  const filterParts = () => {
    let result = filterPrices(parts)
    result = filterQuantitys(result)
    result = filterHighrunner(result)
    result = filterTypes(result)
    result = filterCurrency(result)
    result = filterManufacturer(result)
    result = filterMPN(result)
    result = filterCPN(result)
    result = filterPartnerCockpit(result)
    if (showCompanyCategoryFilter) result = filterCompanyCategory(result)
    setParts(result)
  }

  useEffect(() => {
    filterParts()
  }, [parts])

  useEffect(() => {
    if (showCompanyCategoryFilter) {
      setCompanyCategoryTrader(includeTraderArticles)
    }
  }, [showCompanyCategoryFilter, includeTraderArticles])

  const filterMPN = list => {
    if (mpn)
      return list.filter(
        t =>
          t.partNumber?.toLowerCase()?.startsWith(mpn?.toLowerCase()) ||
          t.mpn?.toLowerCase()?.startsWith(mpn?.toLowerCase())
      )

    return list
  }

  const filterManufacturer = list => {
    if (manufacturer)
      return list.filter(t =>
        t.manufacturer?.toLowerCase()?.startsWith(manufacturer?.toLowerCase())
      )

    return list
  }

  const filterCPN = list => {
    if (cpn)
      return list.filter(
        t =>
          t.cpn?.toLowerCase()?.startsWith(cpn?.toLowerCase()) ||
          t.internalPart?.toLowerCase()?.startsWith(cpn?.toLowerCase())
      )

    return list
  }

  const filterTypes = list => {
    if (type) return list.filter(t => t.type == type)

    return list
  }

  const filterHighrunner = list => {
    if (isHighrunner) return list.filter(t => t.isHighrunner == isHighrunner)

    return list
  }

  const filterQuantitys = list => {
    if (quantityFrom) list = list.filter(t => t.quantity >= quantityFrom)
    if (quantityTo) list = list.filter(t => t.quantity <= quantityTo)

    return list
  }

  const filterPrices = list => {
    if (priceFrom) list = list.filter(t => t.price >= priceFrom)
    if (priceTo) list = list.filter(t => t.price <= priceTo)

    return list
  }
  const filterCurrency = list => {
    if (currency) return list.filter(t => t.currency == currency)
    return list
  }

  const filterPartnerCockpit = list => {
    if (partnerCockpit?.value) {
      const partnerCockpitId = partnerCockpit.value.id
      return list.filter(t => t.partnerCockpitID == partnerCockpitId)
    }
    return list
  }

  const filterCompanyCategory = list => {
    const showOemEms = companyCategoryOemEms
    const showTrader = companyCategoryTrader
    if (showOemEms && showTrader) return list
    if (!showOemEms && !showTrader) return list
    if (showOemEms) return list.filter(t => t.companyCategory !== "Trader")
    return list.filter(t => t.companyCategory === "Trader")
  }

  const clearAll = _ => {
    setPriceFrom(0)
    setPriceTo(0)
    setQuantityFrom(0)
    setQuantityTo(0)
    setIsHighrunner("")
    setType("")
    setCurrency("")
    setManufacturer("")
    setMPN("")
    setCPN("")
    setPartnerCockpit({ value: null, label: "" })
    if (showCompanyCategoryFilter) {
      setCompanyCategoryOemEms(true)
      setCompanyCategoryTrader(includeTraderArticles)
    }
    searchProps.onClear()
  }

  return (
    <Collapse isOpen={isOpen}>
      <Card>
        <CardBody className="border shadow-none text-muted mb-0">
          <Row>
            <Col
              className="d-flex flex-column"
              style={{ maxWidth: "200px", minWidth: "150px" }}
            >
              <label>Search:</label>
              <SearchBar {...searchProps} placeholder=" " />
            </Col>
            {showPartnerCockpitFilter && (
              <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
                <label>Partner Cockpit:</label>
                <Select
                  value={partnerCockpit}
                  onChange={e => setPartnerCockpit(e)}
                  options={partnerCockpits.map(cockpit => ({
                    value: cockpit,
                    label: cockpit.name,
                  }))}
                  className="react-select"
                  classNamePrefix="select"
                />
              </Col>
            )}
            {showCPNFilter && (
              <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
                <label>CPN:</label>
                <input
                  className="form-control"
                  value={cpn}
                  onChange={e => setCPN(e.target.value)}
                />
              </Col>
            )}
            <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
              <label>MPN:</label>
              <input
                className="form-control"
                value={mpn}
                onChange={e => setMPN(e.target.value)}
              />
            </Col>
            <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
              <label>Manufacturer:</label>
              <input
                className="form-control"
                value={manufacturer}
                onChange={e => setManufacturer(e.target.value)}
              />
            </Col>
            <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
              <label>Quantity from:</label>
              <NumberInput
                initial={quantityFrom}
                onChange={e => setQuantityFrom(e)}
              />
            </Col>
            <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
              <label>Quantity to:</label>
              <NumberInput
                initial={quantityTo}
                onChange={e => setQuantityTo(e)}
              />
            </Col>
            <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
              <label>Price from:</label>
              <NumberInput
                initial={priceFrom}
                onChange={e => setPriceFrom(e)}
              />
            </Col>
            <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
              <label>Price to:</label>
              <NumberInput initial={priceTo} onChange={e => setPriceTo(e)} />
            </Col>

            {!isWatchlist && !showPartnerCockpitFilter && (
              <>
                <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
                  <label>Type:</label>
                  <select
                    className="form-select"
                    value={type}
                    onChange={e => setType(e.target.value)}
                  >
                    <option value="">-</option>
                    <option value="APQ">APQ</option>
                    <option value="Excess">Excess</option>
                    {showStockType && <option value="Stock">Stock</option>}
                  </select>
                </Col>
                <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
                  <label>Is Highrunner:</label>
                  <select
                    className="form-select"
                    value={isHighrunner}
                    onChange={e => setIsHighrunner(e.target.value)}
                  >
                    <option value="">-</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </Col>{" "}
                <Col style={{ maxWidth: "200px", minWidth: "150px" }}>
                  <label>Currency:</label>
                  <select
                    className="form-select"
                    value={currency}
                    onChange={e => setCurrency(e.target.value)}
                  >
                    <option value="">-</option>
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                    <option value="GBP">GBP</option>
                    <option value="YEN">YEN</option>
                  </select>
                </Col>
                {showCompanyCategoryFilter && (
                  <Col style={{ maxWidth: "220px", minWidth: "180px" }}>
                    <label>Company type:</label>
                    <div className="d-flex flex-wrap gap-3 mt-1">
                      <label className="d-flex align-items-center gap-1">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={companyCategoryOemEms}
                          onChange={e =>
                            setCompanyCategoryOemEms(e.target.checked)
                          }
                        />
                        OEM/EMS
                      </label>
                      <label className="d-flex align-items-center gap-1">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={companyCategoryTrader}
                          onChange={e =>
                            setCompanyCategoryTrader(e.target.checked)
                          }
                          disabled={!includeTraderArticles}
                        />
                        Trader
                      </label>
                    </div>
                  </Col>
                )}
              </>
            )}

            <Col className="w-auto">
              <button className="btn btn-danger mt-4" onClick={clearAll}>
                Clear All
              </button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Collapse>
  )
}

export default PartFilter
